import React, {useContext} from 'react';
import {useSHCore, AjaxParam} from '@hooks/useSHCore';
import {getInitialComponentData} from "@helpers/HelperInitialPageState";
import {notify} from "@contexts/ContextNotificationProvider";

const ContextOperatorTask = React.createContext({});


/**
 * @function ContextOperatorTaskProvider
 * @property {array} contextData
 * @property {Function} CreateMigrationTask Creates Operator Task for Migration
 * @property {Function} CreatePartnerTask Creates Operator Task for Partner requests
 *
 */
const ContextOperatorTaskProvider = ({children}) => {

	const providerData = getInitialComponentData('contextOperatorTask');

	// All operator tasks share the same flow; only the backend action differs.
	const createOperatorTask = (backendAction) => (
	  actionData,
	  callbackSuccess = () => {
	  },
	  callbackError = null
	) => {
		const ajaxParam = new AjaxParam()
		ajaxParam.isLoading = false
		ajaxParam.callbackSuccess = () => {
			callbackSuccess();
		};
		ajaxParam.callbackError = ({componentErrors}) => {
			const errorMessage = componentErrors[0];
			const message = core.messages[errorMessage] || errorMessage;

			if (callbackError) {
				callbackError(message, errorMessage);
			} else {
				notify.error(message);
			}
		};
		core.ajaxCall(backendAction, actionData, ajaxParam)
	};

	const CreateMigrationTask = createOperatorTask('ActionCreateMigrationTask');
	const CreatePartnerTask = createOperatorTask('ActionCreatePartnerTask');
	const CreateWPSEnterpriseTask = createOperatorTask('ActionSubmitEnterprise');
	const CreateDedicatedTask = createOperatorTask('ActionCreateDedicatedTask');

	const core = useSHCore({
		name: providerData.componentName,
		token: providerData.componentToken,
		initialState: {
			contextData: providerData.componentData,
			CreateMigrationTask,
			CreatePartnerTask,
			CreateWPSEnterpriseTask,
			CreateDedicatedTask
		},
	});

	return (
	  <ContextOperatorTask.Provider value={core.state}>
		  {children}
	  </ContextOperatorTask.Provider>
	);
};

/**
 *
 * @returns {ContextOperatorTaskProvider}
 */
export const useOperatorTaskContext = () => useContext(ContextOperatorTask);

export {ContextOperatorTask, ContextOperatorTaskProvider};

